import { env, parseOptionalEnvBoolean } from '@cntxt/shared/utilities/envs';

/**
 * Local env override for notification SSE on the client (`NEXT_PUBLIC_*`).
 * When set, bypasses Flipt evaluation.
 */
export const getNotificationSseClientEnvOverride = (): boolean | null => {
  return parseOptionalEnvBoolean(env.NEXT_PUBLIC_NOTIFICATION_SSE_ENABLED);
};
